(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('SeekingSettings', SeekingSettings);

    SeekingSettings.$inject = ['$resource'];

    function SeekingSettings ($resource) {
        var resourceUrl =  'api/seeking-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
